const RESTRICTED_FORM_TEXT = {
  title:'You are editing a form that is set up to provide your practice management system with important data',
  closeText: 'Ok, got it.',
  text:  'Because this form is set up to collect data for your practice management system and Legwork database, some fields cannot be deleted or modified.',
};
  
const dateFormat = 'MM-dd-yy';
  
const actions = {
  clone: { action: 'clone', type: 'modal' },
  delete: { action: 'delete', type: 'modal' },
  edit: { action: 'edit', type: 'redirect' },
  move: { action: 'move', type: 'modal' },
  preview: { action: 'preview', type: 'redirect' },
  rename: { action: 'rename', type: 'modal' },
  share: { action: 'share', type: 'redirect' },
  submissions: { action: 'submissions', type: 'redirect' },
};
const LIST_ITEM_URL_BASE = '/form-builder/forms/form/';

const PRIVACY_LINK = {
  url: 'https://www.planetdds.com/privacy-policy/',
  text: 'Privacy Policy',
};

export {
  actions,
  dateFormat,
  LIST_ITEM_URL_BASE,
  PRIVACY_LINK,
  RESTRICTED_FORM_TEXT,
};